import { Box, Button, Link, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade22,
  border25,
  greyColor24,
  lightSkyBlue01,
  mobilePrimary,
  primaryColor,
  whiteColor,
} from "../../configs/styles/muiThemes";

const MobileEmptyCard = ({
  icon,
  iconBGColor,
  title,
  message1,
  message2,
  btnText,
  onClick,
  page,
}) => {
  return (
    <Stack pt={1}>
      <Typography fontSize={16} fontWeight={600} color={blackColor} mt={2}>
        {page || "Reports & Insights"}
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"center"}
        flexDirection={"column"}
        alignItems="center"
        sx={styles.card}
      >
        <Typography
          fontSize={15}
          fontWeight={600}
          color={blackColor}
          width="100%"
          textAlign={"start"}
        >
          {title}
        </Typography>
        <Box sx={styles.infoCardIcon(iconBGColor)} >
          {icon}
        </Box>

        <Typography
          fontSize={12.5}
          fontWeight={500}
          color={greyColor24}
          mt={0.5}
          mb={1}
          textAlign="center"
        >
          {message1
            ? message1
            : "Gain valuable insights on sales, customer behaviour and performance to optimize your strategy with our new reporting feature!"}
        </Typography>
        <Typography
          fontSize={12.5}
          fontWeight={500}
          color={greyColor24}
          // mt={0.5}
          // mb={1.5}
          textAlign="center"
        >
          {message2
            ? message2
            : "This feature is currently available only on our browser web version."}
        </Typography>
        <Typography
          fontSize={12.5}
          fontWeight={500}
          color={greyColor24}
          mt={0.5}
          // mb={1.5}
          textAlign="center"
        >
          {message2
            ? message2
            : "For the best experience and to use this feature, please switch to a desktop or laptop computer and access our site through a standard web browser."}
        </Typography>

        <Box sx={{ textAlign: "center" }}>
          <Link
            href="https://business.costbo.com/"
            underline="hover"
            target="_blank"
            rel="noopener"
            sx={{
              color: mobilePrimary,
              fontWeight: "bold",
              "&:hover": {
                color: mobilePrimary,
                backgroundColor: whiteColor,
              },
            }}
          >
            https://business.costbo.com/
          </Link>
        </Box>

        {btnText && (
          <Button onClick={onClick} sx={styles.editBtn}>
            {btnText}
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default MobileEmptyCard;

const styles = {
  infoCardIcon: (iconBGColor) => ({
    width: "45px",
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: iconBGColor || lightSkyBlue01,
    borderRadius: "50%",
  }),
  card: {
    bgcolor: whiteColor,
    border: border25,
    p: "20px 20px 15px 20px",
    borderRadius: "14px",
    mt: 1,
  },

  editBtn: {
    backgroundColor: blackShade22,
    padding: "2px 14px",
    fontSize: "12px",
    fontWeight: 600,
    color: whiteColor,
    border: "1.5px solid " + blackShade22,
    textTransform: "unset",
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },
  },
};
